import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node }, load) => {
  const searchParams = new URLSearchParams(window.location.search);
  const urlParam = node.dataset.loadUrlParam?.split(':');

  if (!urlParam) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(node, 'Element needs a data-load-url-param attribute');
    }

    return () => {};
  }

  const [key, value] = urlParam;

  if (searchParams.has(key)) {
    if (value) {
      if (searchParams.get(key) === value) {
        load();
      }
    } else {
      load();
    }
  }

  return () => {};
};

export default Loader;
